@if(!isDisabled) {
<div
    class="w-screen h-screen transition-all duration-700 fixed top-0 left-0 bg-primary-tselWhite loader-section overflow-hidden flex items-center justify-center p-0 m-0"
    [ngClass]="{'opacity-0 hidden': !isLoading || (queue | async) === 0, 'bg-transparent': config?.bgTransparent, 'bg-white': config?.bgTransparent}">
    <img class="animate-spin" src="assets/images/loader.png" alt="loader">
</div>
}